import React from "react";
import { Link } from "react-router-dom";
import "./CategorySection.css";
import { resolveAssetUrl } from "../utils/assets";

const accents = ["#ffb347", "#2f8f7f", "#c9704f"];

const CategorySection = ({ data }) => {
  const items = data?.items || [];

  return (
    <section className="category-section" id="categories">
      <div className="category-header">
        {data?.subtitle && (
          <span className="category-subtitle">{data.subtitle}</span>
        )}
        {data?.title && <h2>{data.title}</h2>}
        {data?.description && <p>{data.description}</p>}
      </div>

      <div className="category-grid">
        {items.map((category, index) => {
          const accent = category.accentColor || accents[index % accents.length];
          const imageSrc =
            resolveAssetUrl(category.image) || category.image || "";
          const href = category.link || "/products";

          return (
            <Link
              to={href.startsWith("/") ? href : `/${href}`}
              className="folder-card"
              key={`${category.title}-${index}`}
              style={{ "--accent": accent }}
            >
              <div className="folder-body">
                <div className="folder-image-window">
                  {imageSrc && (
                    <img src={imageSrc} alt={category.title} />
                  )}
                </div>

                <div className="folder-perforation" aria-hidden="true" />

                <div className="folder-info">
                  <h3>{category.title}</h3>
                  <span className="folder-cta">
                    Explore
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.5 8H12.5M12.5 8L8.5 4M12.5 8L8.5 12"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default CategorySection;
